var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support-team",
    transform: "translate(0.028 0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(-0.028 -0.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M120.972,60.466a60.157,60.157,0,0,1-8.99,31.76A59.03,59.03,0,0,1,107.86,98.1q-.772,1-1.594,1.925h0l-.03.035c-.381.436-.762.862-1.148,1.288q-1.5,1.669-3.174,3.2-.612.587-1.233,1.128c-.246.226-.5.441-.742.657h0c-.607.5-1.228,1.038-1.855,1.534q-2.246,1.79-4.668,3.364c-.346.226-.7.451-1.053.672-.577.356-1.158.707-1.745,1.043q-2.216,1.278-4.553,2.371c-.677.316-1.364.617-2.056.912s-1.5.622-2.3.912q-1.6.6-3.239,1.108c-.531.165-1.068.326-1.6.5a60.022,60.022,0,0,1-6.684,1.434q-2.9.466-5.876.652-1.89.12-3.806.12H58.218A60.348,60.348,0,0,1,40.4,117.574q-1.264-.446-2.507-.948c-.647-.256-1.284-.526-1.915-.807s-1.253-.572-1.875-.877h0q-1.92-.922-3.755-2.005a61.2,61.2,0,0,1-10.564-7.716c-.582-.531-1.153-1.073-1.715-1.634-.15-.14-.3-.291-.451-.446a60.49,60.49,0,1,1,93.329-76.029q1.625,2.447,3.008,5.059a59.412,59.412,0,0,1,4.327,10.423,60.217,60.217,0,0,1,2.657,15.772h0c0,.336,0,.672.025,1h0C120.967,59.739,120.972,60.1,120.972,60.466Z",
    transform: "translate(0.028 0.042)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M113.959,32.214q-4.407-1.645-8.584-2.948-2.412-.752-4.748-1.394c-83.01-22.9-96.4,54.912-96.4,54.912h0A60.5,60.5,0,0,1,110.951,27.155Q112.575,29.6,113.959,32.214Z",
    transform: "translate(0.021 0.001)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M212.48,81.273c0,.336,0,.672.025,1L183.57,66.868h0l8.589-16.125,2.582-4.843,7.741,4.126q1.625,2.447,3.008,5.059A59.418,59.418,0,0,1,209.823,65.5a60.227,60.227,0,0,1,2.657,15.774Z",
    transform: "translate(-91.515 -22.868)",
    fill: "#ffb100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M212.505,100.545,183.57,85.127h0l17.659-2.256,2.733-.351,1.228,2.457,7.285,14.54h0C212.49,99.868,212.5,100.2,212.505,100.545Z",
    transform: "translate(-91.515 -41.129)",
    fill: "#ffc600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M220.937,65.519l-4.628,1.218-2.958.787-1-2.883-4.322-12.475L205.86,45.93l7.741,4.126q1.625,2.447,3.008,5.059a59.42,59.42,0,0,1,4.327,10.4Z",
    transform: "translate(-102.63 -22.883)",
    fill: "#ffd741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M212.485,118.71s-.662,12.535-8.428,10.168a5.182,5.182,0,0,1-1.073-5.47C204.668,119.5,210.524,119.512,212.485,118.71Z",
    transform: "translate(-100.997 -59.175)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M185.866,137.921s2.166-1.3,1.7-4.874-4.116-6.187-4.116-6.187a9.3,9.3,0,0,0-2.2,7.571C181.986,138.964,185.866,137.921,185.866,137.921Z",
    transform: "translate(-90.307 -63.239)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M216.484,150.671s-.326,8.724-7.551,6.277a4.638,4.638,0,0,1,.857-4.417C211.8,150.049,216.484,150.671,216.484,150.671Z",
    transform: "translate(-104.048 -75.078)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M175.453,158.41a6.959,6.959,0,0,0-.757-6.137c-1.835-3.008-6.448-4.513-6.448-4.513s-2.146,5.37,1.153,9.326C171.848,159.994,175.453,158.41,175.453,158.41Z",
    transform: "translate(-83.534 -73.661)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M194.877,154.057a44.393,44.393,0,0,1,2.176-17.418,34.5,34.5,0,0,1,3.8-7.937l1.233-1.83,1.4-1.7c.241-.281.461-.577.712-.847l.782-.772L206.554,122a.361.361,0,0,1,.5.5h-.03l-1.5,1.534-.757.767c-.241.266-.451.557-.677.832l-1.344,1.68-1.173,1.805a33.667,33.667,0,0,0-3.595,7.787,43.34,43.34,0,0,0-1.88,16.962v.04a.617.617,0,1,1-1.228.12Z",
    transform: "translate(-97.091 -60.785)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M191.5,144.58a13.743,13.743,0,0,1-2.768-3.109,19.923,19.923,0,0,1-1.905-3.635,23.37,23.37,0,0,1-1.123-3.926c-.155-.667-.206-1.344-.316-2.006s-.1-1.354-.15-2.006a.286.286,0,0,1,.567-.05v.025c.06.662.105,1.324.186,1.98a16.175,16.175,0,0,0,.336,1.96,23,23,0,0,0,1.158,3.791,19.429,19.429,0,0,0,1.89,3.46,13.2,13.2,0,0,0,2.617,2.853l.03.025a.426.426,0,0,1-.5.677Z",
    transform: "translate(-92.348 -64.614)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M209.3,152.858a26.922,26.922,0,0,1-2.758,2.642,23.833,23.833,0,0,1-3.144,2.2,22.762,22.762,0,0,1-3.445,1.675,17.418,17.418,0,0,1-3.725,1.033.413.413,0,0,1-.125-.817h.035a17.117,17.117,0,0,0,3.545-.928,22.75,22.75,0,0,0,3.359-1.574,23.135,23.135,0,0,0,3.064-2.1,26.611,26.611,0,0,0,2.728-2.537h0a.3.3,0,0,1,.426,0A.306.306,0,0,1,209.3,152.858Z",
    transform: "translate(-97.589 -75.957)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M182.831,163.4a12.876,12.876,0,0,1-4.437-1.875,19.329,19.329,0,0,1-3.62-3.043,24.859,24.859,0,0,1-2.858-3.74c-.421-.657-.777-1.354-1.168-2.031l-1-2.116a.251.251,0,1,1,.451-.221h0l1.048,2.056c.4.652.767,1.329,1.193,1.96a24.017,24.017,0,0,0,2.863,3.57,18.651,18.651,0,0,0,3.545,2.828,12.158,12.158,0,0,0,4.1,1.64H183a.483.483,0,0,1-.16.953Z",
    transform: "translate(-84.609 -74.893)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M195.338,184a59.031,59.031,0,0,1-4.121,5.871H167.15V184Z",
    transform: "translate(-83.328 -91.732)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M192.433,195.655q-.772,1-1.594,1.925h0l-.03.035c-.381.436-.762.862-1.148,1.289q-1.5,1.67-3.174,3.2-.612.587-1.233,1.128c-.246.226-.5.441-.742.657h0c-.607.5-1.228,1.038-1.855,1.534q-2.246,1.79-4.668,3.364a60.911,60.911,0,0,1-6.754-5.33l-1.228-5.846h0l-.416-1.965Z",
    transform: "translate(-84.545 -97.544)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M192.428,195.655q-.772,1-1.594,1.925h0l-.03.035H170l-.416-1.965Z",
    transform: "translate(-84.54 -97.544)",
    fill: "#af865d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M105.233,74.605c.6,2.682-.652,5.245-2.783,5.721S98.1,79.007,97.5,76.315s.647-5.245,2.783-5.721S104.631,71.918,105.233,74.605Z",
    transform: "translate(-48.526 -35.143)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M117.686,90.493a22.46,22.46,0,0,1-14.616-9.677l.877-.536c.045.08,4.763,7.656,13.909,9.2Z",
    transform: "translate(-51.377 -40.011)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M133.129,98.994a1.549,1.549,0,1,1-1.544-1.544,1.549,1.549,0,0,1,1.544,1.544Z",
    transform: "translate(-64.82 -48.573)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M118.764,164.246c-.246.226-.5.441-.742.657h0c-.607.5-1.228,1.038-1.855,1.534a61.817,61.817,0,0,1-5.721,4.036c-.8-2.507-1.594-5.2-2.3-7.631h0q-.391-1.339-.732-2.537a3.058,3.058,0,0,1-1.645,2.276l-.13.08c-2.667,1.614-3.51,6.608-3.545,12.164-.757.321-1.5.622-2.3.913q-1.6.6-3.239,1.108c-.531.165-1.068.326-1.6.5a60.018,60.018,0,0,1-6.689,1.429q-2.9.466-5.876.652-1.89.12-3.806.12H76.3a60.342,60.342,0,0,1-17.819-3.384c0-.06,0-.115,0-.175-.13-6.368-3.43-19.083-4.157-21.805l-.03-.12-.03-.11v-.1a.525.525,0,0,0,0-.1v-.1s-8.308,8.729-11.582,14.039a59.512,59.512,0,0,1-4.728-3.886c-.582-.531-1.153-1.073-1.715-1.635,1.85-7.787,4.573-17.7,6.924-25.225,3.058-6.152,5.7-11.131,6.548-11.738,1.284-.923,6.679-3.234,11.392-5.1l.461-.186,1.294-.5.622-.241.331-.125h.07l.2-.075a35.79,35.79,0,0,1,4.513-1.544,2.721,2.721,0,0,1,.291,0l.572.03h0l.737.05c3.184.221,10,.852,13.036,1.138l.306.03.326.03.872.085h0l.918.416.662.3h0l1.755.8.186.085.175.08h.04l.251.12c.913.436,1.91.958,2.963,1.5l.672.366c2.908,1.594,6.117,3.46,8.779,4.728a21.931,21.931,0,0,1,4.989,3.535Z",
    transform: "translate(-18.055 -58.548)",
    fill: "#decbc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M108.077,43.853s14.631-4.693,12.866,14.4-5.2,20.873-14.54,17.784S96.8,60.845,95.823,54.979,103.339,44.48,108.077,43.853Z",
    transform: "translate(-47.725 -21.593)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M117.719,105.6s-5.987,7.591-17,2.146c0,0,1-15.393-.892-22.678s14.646,10.253,14.646,10.253c-.191.12-.256.837-.2,1.845a20.782,20.782,0,0,0,.421,3.008C115.227,102.6,116.22,105.124,117.719,105.6Z",
    transform: "translate(-49.686 -41.517)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M95.768,60.43s-.135-5.952,2.006-6.328,2.692,1.991,2.692,1.991l2.216.221s-1.148-5.139.933-6.237,14.234,1.619,15.829-.055-.145-12.124-3.4-13.287-12.2-3.625-18.16,1.228c0,0-5.014-.125-5.37,3.926S94.163,57.6,95.768,60.43Z",
    transform: "translate(-46.091 -17.465)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M117.235,108.1c-11.071-2.372-12.455-8.789-12.475-8.89,4.086,5.786,12.033,5.891,12.033,5.891a20.782,20.782,0,0,0,.441,3Z",
    transform: "translate(-52.22 -49.451)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M79.413,153.547c0-.4-.03-.8-.065-1.193h0a1.546,1.546,0,0,0-.03-.371c-.055-.642-.135-1.284-.236-1.92l-.07-.426q-.06-.376-.135-.752c-.04-.211-.085-.426-.13-.637-.06-.3-.125-.587-.2-.882a.687.687,0,0,0-.035-.145c-.07-.306-.15-.617-.236-.923s-.155-.572-.241-.857-.13-.436-.2-.657c-.2-.632-.406-1.259-.637-1.88-.09-.246-.18-.5-.276-.742s-.175-.456-.266-.687-.241-.6-.366-.9c-.065-.15-.125-.3-.191-.446-.16-.381-.326-.762-.5-1.133s-.356-.777-.542-1.163l-.211-.426c-.657-1.339-1.354-2.632-2.066-3.871-.12-.206-.236-.411-.356-.612-.2-.346-.406-.687-.612-1a.125.125,0,0,0,0-.035c-.181-.291-.356-.582-.536-.867q-.637-1-1.274-1.97c-.241-.361-.476-.707-.712-1.048l-.446-.642-.03-.045-.221-.306c-.226-.326-.451-.637-.672-.938-.11-.155-.221-.3-.331-.446s-.216-.291-.321-.431c-.246-.336-.5-.652-.722-.953l-.261-.336q-.135-.181-.271-.346l-.436-.552c-.105-.135-.211-.261-.306-.386l-.451-.547c-.181-.221-.351-.421-.5-.6-.075-.09-.145-.175-.216-.251-.331-.4-.562-.652-.657-.757l-.2.075h-.07l-.331.125-.622.241-1.294.5-.461.186c-4.843,1.9-14.57,5.2-15.854,6.117-.742.531-2.116,7.2-4.011,13.337a213.194,213.194,0,0,0-5.43,22.161c.15.155.3.306.451.446.562.562,1.133,1.1,1.715,1.635a61.2,61.2,0,0,0,10.564,7.716c-.511-8.353,5.731-17.865,5.731-17.865v.075a.525.525,0,0,1,0,.1v.1l.03.11.03.12c.958,4.162,1.5,16.07,1.665,21.058q1.233.5,2.507.948a60.343,60.343,0,0,0,17.819,3.384h.5c.246-.953.456-1.945.622-2.978.13-.8.251-1.589.366-2.377.05-.326.1-.652.14-.978.09-.652.181-1.3.266-1.935.04-.316.085-.637.125-.953.055-.5.115-.953.175-1.424v-.08c.04-.316.075-.632.11-.943q.12-1,.226-2.006c.05-.466.1-.928.145-1.379.12-1.153.231-2.266.331-3.324.04-.426.075-.837.115-1.243.17-1.82.311-3.46.441-4.848.07-.737.1-1.474.1-2.216A2.719,2.719,0,0,0,79.413,153.547Z",
    transform: "translate(-17.527 -60.058)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M171.484,165.934q-.612.587-1.233,1.128c-.246.226-.5.441-.742.657h0c-.607.5-1.228,1.038-1.855,1.534a61.813,61.813,0,0,1-5.721,4.036c-.577.356-1.158.707-1.745,1.043-.246-.627-.5-1.264-.732-1.905-.792-2.091-1.579-4.237-2.291-6.207a.171.171,0,0,0,0-.06.305.305,0,0,0-.025-.06,105.725,105.725,0,0,0-1.5,10.6c-.677.316-1.364.617-2.056.913s-1.5.622-2.3.913q-1.6.6-3.239,1.108l-.105-.933h0c-.251-2.256-.5-4.513-.757-6.729-.5-4.412-1.1-9.657-1.795-15.112-.15-1.208-.3-2.367-.441-3.465-.3-2.241-.607-4.513-.928-6.724v-.1c-1.344-9.341-2.893-18.18-4.513-23.485l.186.085.175.08h.04l.251.12.241.11.291.13.326.15.3.14.326.145.421.2.261.12.446.206.266.125c5.42,2.507,14.275,6.6,15.2,7.335Z",
    transform: "translate(-69.542 -61.364)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M92.416,135.933l5.9,3.324-2.507,2.567,6.7,36.2c1.369-8.484,2.006-16.546,2.452-21.485,1.539-16.441-14.871-34.992-15.894-36.125-.787.3-1.64.627-2.507.973Z",
    transform: "translate(-43.145 -60.028)",
    fill: "#0061aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M135.93,121.48s3.961,8.022,6.518,25.947c1,6.894,2.367,18.632,3.69,30.475l1.374-33.894-2.808-3.043,2.507-3.119-5.987-13.934c-1.459-.677-2.181-1-3.344-1.539Z",
    transform: "translate(-67.762 -60.562)",
    fill: "#0061aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M90.94,117.6l5.686-2.968s1.349,4.653,11.437,9.677l-3.435,9.682Z",
    transform: "translate(-45.329 -57.141)",
    fill: "#f5e2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M127.371,116.94s.747,3.084-2.281,8.524l6.709,8.744-1.274-14.987Z",
    transform: "translate(-62.357 -58.293)",
    fill: "#f5e2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M124.13,133.93s-1.3,5.2-.832,6.658c0,0,2.858,1.038,4.909-.261a22.884,22.884,0,0,0-4.076-6.4Z",
    transform: "translate(-61.412 -66.765)",
    fill: "#495055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M133.443,180.039c-.276,4.773-.592,8.789-.913,12.129q-2.9.466-5.876.652c1.1-9.316,1.925-22.783-.025-36.04-.451-3.079-1.058-8.128-1.369-10.76-.125-1.053-.2-1.72-.2-1.72l2.913.727s.12.3.321.867C129.6,149.524,134.366,164.045,133.443,180.039Z",
    transform: "translate(-62.342 -71.94)",
    fill: "#495055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M175.261,195.906c-.792-2.091-1.579-4.237-2.291-6.207a.846.846,0,0,0-.04-.12h0s.03-3.946-.186-8.378c-.206-4.2-.637-8.85-1.534-11.031.12.2,3.916,6.714,4.227,18.958a65.831,65.831,0,0,1-.175,6.779Z",
    transform: "translate(-85.353 -84.839)",
    fill: "#0061aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M105.233,74.605c.6,2.682-.652,5.245-2.783,5.721S98.1,79.007,97.5,76.315s.647-5.245,2.783-5.721S104.631,71.918,105.233,74.605Z",
    transform: "translate(-48.526 -35.143)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M117.686,90.493a22.46,22.46,0,0,1-14.616-9.677l.877-.536c.045.08,4.763,7.656,13.909,9.2Z",
    transform: "translate(-51.377 -40.011)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M133.129,98.994a1.549,1.549,0,1,1-1.544-1.544,1.549,1.549,0,0,1,1.544,1.544Z",
    transform: "translate(-64.82 -48.573)",
    fill: "#807066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M48.9,42.388,21.72,47.683,44.929,32.12Z",
    transform: "translate(-10.816 -15.994)",
    fill: "#cbe3fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M51.277,64.042l3.344,8.674L21.72,63.16Z",
    transform: "translate(-10.816 -31.474)",
    fill: "#cbe3fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M21.72,63.16l23.2,8.554,6.358-7.671Z",
    transform: "translate(-10.816 -31.474)",
    fill: "#b0cef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M48.9,52.6,44.919,66.448l-23.2-8.554Z",
    transform: "translate(-10.816 -26.209)",
    fill: "#e1effa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M91.716,167.229,88,167.5a.211.211,0,0,1-.175-.346l1.329-1.544a1.5,1.5,0,0,1,2.116-.155l.807.692a.617.617,0,0,1-.356,1.078Z",
    transform: "translate(-43.749 -82.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M88.169,178.8l3.72-.276a.211.211,0,0,1,.175.346l-1.329,1.544a1.5,1.5,0,0,1-2.116.155l-.827-.692a.617.617,0,0,1,.376-1.078Z",
    transform: "translate(-43.656 -88.999)",
    fill: "#140958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M87.556,174.416l6.333-.476c.276,0,.446.4.271.662l-.7,1.033a.281.281,0,0,1-.216.13l-4.793.361a.281.281,0,0,1-.226-.1l-.842-.918C87.17,174.873,87.275,174.436,87.556,174.416Z",
    transform: "translate(-43.5 -86.716)",
    fill: "#140958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M83.075,171.644l.732-1.038a.311.311,0,0,1,.221-.135l5.014-.371a.316.316,0,0,1,.241.1l.877.913c.221.236.11.672-.181.692l-6.618.5C83.07,172.321,82.89,171.9,83.075,171.644Z",
    transform: "translate(-41.37 -84.801)",
    fill: "#140958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTeam);
export default __webpack_public_path__ + "static/media/support-team.9fdd2ffa95e61d4418b1ffcef621bc8d.svg";
export { ForwardRef as ReactComponent };